import {createSelector} from 'reselect';

import * as utils from 'app/procedures/utils';
import {getBasicTeamsFromRelated} from 'app/teams/utils';

import type {
  ListResponseType,
  ProcessHashidSerializedType,
  ProcessSerializedType,
  ProcessVersionSerializedType,
  RawProcessHashidSerializedType,
  RawProcessSerializedType,
  RawProcessVersionSerializedType,
  RelatedTeamsSerializedType,
} from 'sweet-types';

// Formatting process description according to procedure description
// so, that the generic file VersionDiffer can compute description differ easily without checks
export const formatPreviousProcessVersion = createSelector<
  ProcessVersionSerializedType | void,
  ProcessVersionSerializedType | undefined,
  ProcessVersionSerializedType | void
>(
  (process) => process,
  (process) =>
    process != null
      ? {...process, description: utils.getDescription(process)}
      : undefined
);

export function standardizeRawProcess(
  doc: RawProcessHashidSerializedType,
  related?: RelatedTeamsSerializedType
): ProcessHashidSerializedType;
export function standardizeRawProcess(
  doc: RawProcessSerializedType,
  related?: RelatedTeamsSerializedType
): ProcessSerializedType;
export function standardizeRawProcess(
  doc: RawProcessHashidSerializedType | RawProcessSerializedType,
  related?: RelatedTeamsSerializedType
): ProcessHashidSerializedType | ProcessSerializedType {
  return {
    ...doc,
    description: utils.getDescription(doc),
    team_names: getBasicTeamsFromRelated(doc, related),
  };
}

export function standardizeRawProcessVersion(
  doc: RawProcessVersionSerializedType
): ProcessVersionSerializedType {
  return {
    ...doc,
    description: utils.getDescription(doc),
  };
}

export function standardizeRawProcessVersions(
  doc: ListResponseType<RawProcessVersionSerializedType>
): ListResponseType<ProcessVersionSerializedType> {
  return {
    ...doc,
    results: doc.results.map(standardizeRawProcessVersion),
  };
}
